import React from 'react';
import { useQuickDuelStats } from '../../hooks/useQuickDuelStats';
import HrnbCard from '../controls/HrnbCard';
import HrnbLoader from '../controls/HrnbLoader';
import '../../css/duels/QueueStats.css';

/**
 * Компонент отображения статистики очереди быстрых дуэлей
 */
function QueueStats() {
    const { stats, isLoading, error } = useQuickDuelStats();

    if (isLoading) {
        return (
            <HrnbCard title="📊 Статистика очереди">
                <div className="queue-stats__loading">
                    <HrnbLoader size="md" />
                    <span>Загрузка статистики...</span>
                </div>
            </HrnbCard>
        );
    }

    if (error || !stats) {
        return null;
    }

    const formatWaitTime = (seconds) => {
        // Защита от отрицательных и некорректных значений
        if (seconds === null || seconds === undefined) return '—';
        const safeSeconds = Math.max(0, Math.floor(seconds));
        if (safeSeconds < 60) return `${safeSeconds} сек`;
        return `${Math.floor(safeSeconds / 60)} мин ${safeSeconds % 60} сек`;
    };

    return (
        <HrnbCard title="📊 Статистика очереди">
            <div className="queue-stats">
                <div className="queue-stats__grid">
                    <div className="queue-stats__item">
                        <span className="queue-stats__value">{stats.activeQueues || 0}</span>
                        <span className="queue-stats__label">В очереди</span>
                    </div>
                    
                    <div className="queue-stats__item">
                        <span className="queue-stats__value">{stats.soloQueues || 0}</span>
                        <span className="queue-stats__label">Соло</span>
                    </div>
                    
                    <div className="queue-stats__item">
                        <span className="queue-stats__value">{stats.team2v2Queues || 0}</span>
                        <span className="queue-stats__label">2v2</span>
                    </div>
                    
                    <div className="queue-stats__item">
                        <span className="queue-stats__value">
                            {formatWaitTime(stats.averageWaitSeconds)}
                        </span>
                        <span className="queue-stats__label">Среднее ожидание</span>
                    </div>
                </div>
            </div>
        </HrnbCard>
    );
}

export default QueueStats;
